<template>
  <div>
    <div class="img-container">
      <img src="../../assets/images/footer.webp" alt="" />
    </div>
    <div class="content-container">
      <div class="title">
        <div class="logo">
          <img src="../../assets/images/logo-2.png" alt="" />
        </div>
        <div class="text">
          {{$t('common.footer.slogan')}}
        </div>
      </div>
      <div class="nav">
        <h1 class="common-title">{{$t('common.footer.map.website-map')}}</h1>
        <div class="common-item"><router-link to="/about">{{$t('common.navigation.title.about')}}</router-link></div>
        <div class="common-item"><router-link to="/query">{{$t('common.navigation.title.query')}}</router-link></div>
        <div class="common-item"><router-link to="/track">{{$t('common.navigation.title.track')}}</router-link></div>
        <div class="common-item"><router-link to="/contact">{{$t('common.navigation.title.contact')}}</router-link></div>
      </div>
      <div class="help">
        <h1 class="common-title">{{$t('common.footer.map.help-center')}}</h1>
        <div class="common-item"><a href="javascript:;" @click="showModal">{{$t('common.footer.map.help-center.question')}}</a></div>
        <div class="common-item"><a href="javascript:;" @click="showModal">{{$t('common.footer.map.help-center.service')}}</a></div>
        <div class="common-item"><a href="javascript:;" @click="goContact">{{$t('common.footer.map.help-center.message')}}</a></div>
        <div class="common-item"><a href="javascript:;" @click="showModal">{{$t('common.footer.map.help-center.price')}}</a></div>
      </div>
      <div class="contact-us">
        <h1 class="common-title">{{$t('common.footer.map.contact-us')}}</h1>
        <div class="contact-item">{{$t('common.footer.map.contact-us.whatsApps')}}</div>
        <div class="contact-item">{{$t('common.footer.map.contact-us.skype')}}</div>
        <div class="contact-item"><strong>{{$t('common.company.address-title')}}</strong>{{$t('common.company.address-info')}}</div>
      </div>
    </div>
    <div class="footer-container">
      <a-space size="large">
        <span>{{$t('common.company.copyright')}}</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{$t('common.company.beian.icp')}} 8888888</a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14082802000138" target="_blank">{{$t('common.company.beian.gwa')}} 88888888</a>
      </a-space>
    </div>

    <!-- 模态框 -->
    <a-modal v-model="visible" :title="$t('common.footer.dialog.title')" :footer="null" @cancel="visible=false" centered>
      <p>{{$t('common.footer.dialog.content')}} </p>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible:false
    };
  },
  methods:{
    showModal(){
      this.visible = true
    },
    goContact(){
      this.$router.push('/contact')
    }
  }
};
</script>

<style lang="less" scoped>
.img-container {
  img {
    width: 100%;
  }
}

.content-container {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding: 100px 72px;
  background-color: #40404b;

  .common-title{
    margin-bottom: 24px;
      font-size: 24px;
      position: relative;
      color: #ff5d1b;

      &::after {
        content: "";
        display: block;
        position: absolute;
        margin-top: 8px;
        width: 38px;
        height: 3px;
        border-radius: 2px;
        background-color: #fff;
      }
  }

  .common-item{
    padding: 3px 0;
      a {
        color: #fff;
        &:hover {
          color: #ff5d1b;
        }
      }
  }

  .title {
    width: 300px;
    margin: -36px 0 0 0;

    .logo {
      margin-left: -24px;
      width: 320px;
      img {
        width: 100%;
      }
    }

    .text {
      color: #fff;
    }
  }
  // .nav {
  //   // width: 300px;

  // }
  // .help {
  //   // width: 300px;

  // }
  .contact-us {
    width: 300px;
    // background-color:red;
    color: #fff;
    .contact-item{
      padding: 3px 0;
    }
  }
}

.footer-container {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  background-color: #ff5d1b;
  color: #fff;
  a {
    color: #fff;
  }
}
</style>